export default "__VITE_ASSET__Dc836_TR__"